export let societyPricesSimulationsPreconfig = {
    simulation1 : {
        start: "2020-01-01T13:07",
        end: "2020-01-01T14:46",
        kilometers: 14,
        totalTime: "",
        kmAmount: 0,
        hourAmount: 0,
        reservationAmount: 0,
        discountAmount: 0,
        totalAmount: 0
    },
    simulation2 : {
        start: "2020-01-01T14:00",
        end: "2020-01-02T18:00",
        kilometers: 110,
        totalTime: "",
        kmAmount: 0,
        hourAmount: 0,
        reservationAmount: 0,
        discountAmount: 0,
        totalAmount: 0
    },
    simulation3 : {
        start: "2020-01-01T14:57",
        end: "2020-01-01T19:24",
        kilometers: 45,
        totalTime: "",
        kmAmount: 0,
        hourAmount: 0,
        reservationAmount: 0,
        discountAmount: 0,
        totalAmount: 0
    },
    simulation4 : {
        start: "2020-01-18T10:25",
        end: "2020-01-25T14:56",
        kilometers: 1076,
        totalTime: "",
        kmAmount: 0,
        hourAmount: 0,
        reservationAmount: 0,
        discountAmount: 0,
        totalAmount: 0
    }
}